module.exports = __webpack_public_path__ + "static/floral-7200e4200d86a67b23d940ddbb7b3175.png";